export const COMMANDS = ['ls', 'cat', 'cd', 'cowsay']
